import React from "react";
import { Box } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentSms, faPhone } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { MobilePhlebotomyPhoneNumber, formatPhoneDisplay } from "../types";
import BaseCard from "../components/BaseCard";
import {
  LocationName,
  LocationPhone,
  LocationTitleRow,
  OutlineIconActionButton,
  PhlebotomyCardActionsRow,
  PhlebotomyPrimaryActionButton,
} from "../components/BaseCard.styles";
import PhlebotomyCardMetadata from "../components/PhlebotomyCardMetadata";

interface PhlebotomyPhoneCardProps {
  phone: MobilePhlebotomyPhoneNumber;
  onButtonClick: (
    action: "call" | "text",
    phone: MobilePhlebotomyPhoneNumber,
  ) => void;
}

const PhlebotomyPhoneCard: React.FC<PhlebotomyPhoneCardProps> = ({
  phone,
  onButtonClick,
}) => {
  const { t } = useTranslation();

  const handlePhoneCall = (e: React.MouseEvent) => {
    e.stopPropagation();
    onButtonClick("call", phone);
  };

  const handleTextMessage = (e: React.MouseEvent) => {
    e.stopPropagation();
    onButtonClick("text", phone);
  };

  const cardActions = (
    <PhlebotomyCardActionsRow>
      {phone.callToBook && phone.textToBook && (
        <OutlineIconActionButton
          variant="unity-outline-orange"
          aria-label={t("phlebotomyLocationFinder.card.call")}
          onClick={handlePhoneCall}
        >
          <FontAwesomeIcon icon={faPhone} />
        </OutlineIconActionButton>
      )}
      {phone.textToBook ? (
        <PhlebotomyPrimaryActionButton
          variant="unity-primary"
          onClick={handleTextMessage}
          startIcon={<FontAwesomeIcon icon={faCommentSms} />}
        >
          {t("phlebotomy.buttons.text")}
        </PhlebotomyPrimaryActionButton>
      ) : (
        phone.callToBook && (
          <PhlebotomyPrimaryActionButton
            variant="unity-primary"
            onClick={handlePhoneCall}
            startIcon={<FontAwesomeIcon icon={faPhone} />}
          >
            {t("phlebotomyLocationFinder.card.call")}
          </PhlebotomyPrimaryActionButton>
        )
      )}
    </PhlebotomyCardActionsRow>
  );

  return (
    <BaseCard actions={cardActions} showBorder={false}>
      <Box sx={{ width: "100%" }}>
        <LocationTitleRow>
          <LocationName>{phone.name}</LocationName>
        </LocationTitleRow>
        <LocationPhone>{formatPhoneDisplay(phone)}</LocationPhone>
        <PhlebotomyCardMetadata
          lines={phone.notes}
          keyPrefix={`phone-${phone.number}`}
          splitHours={false}
        />
      </Box>
    </BaseCard>
  );
};

export default PhlebotomyPhoneCard;
